export default __webpack_public_path__ + "static/media/raccoon.da50d7ab.svg";